/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ org: NonNullable<unknown> }} Onboarding_Org_CreatingInputs */



/**
* | output |
* | --- |
* | "You're setting up a new organization: **{org}**. As its first admin you decide who joins, which models are available, and how oneAI is used." |
*
* @param {Onboarding_Org_CreatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_org_creating = /** @type {((inputs: Onboarding_Org_CreatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Org_CreatingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Du richtest eine neue Organisation ein: **${i?.org}**. Als erster Admin entscheidest du, wer dazukommt, welche Modelle verfügbar sind und wie oneAI genutzt wird.`)
	return /** @type {LocalizedString} */ (`You're setting up a new organization: **${i?.org}**. As its first admin you decide who joins, which models are available, and how oneAI is used.`)
});